import { gql } from "@/services/httpAdapter";

export const onCreateDraws = gql`
	subscription onCreateDraws($commissionCycleId: String!, $payPeriodId: String!) {
		onCreateDraws(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			_id
			locationId
			commissionCycleId
			payPeriodId
			draws {
				drawItems {
					drawType
					amount
				}
				user {
					_id
					fullName
					position
				}
			}
			createdAt
			updatedAt
		}
	}
`;
